import React from 'react';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { convertMilitaryStringToAmPm } from '../helper';

const useStyles = makeStyles(() => ({
  detailText: {
    color: '#000',
  },
}));

const RecurringPlanCustomerDetails = ({ customer, vehicle, sw }) => {
  const {
    customer_address,
    client_location,
    planned_arrival_time,
    planned_departure_time,
  } = sw || {};
  const { address_line_1, city } = customer_address || {};
  const { short_name } = client_location || {};

  const classes = useStyles();

  return (
    <DialogContentText className={classes.detailText}>
      <Typography>
        {customer.first_name} {customer.last_name}
      </Typography>
      {vehicle && (
        <Typography>
          {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
        </Typography>
      )}
      <Typography>
        {address_line_1 ? `${address_line_1}, ${city}` : short_name}
      </Typography>
      {planned_arrival_time && planned_departure_time && (
        <Typography>
          {convertMilitaryStringToAmPm(planned_arrival_time)} -{' '}
          {convertMilitaryStringToAmPm(planned_departure_time)}
        </Typography>
      )}
    </DialogContentText>
  );
};

export default RecurringPlanCustomerDetails;
